import type { TargetStatus } from '../../../types/collection-targets'

export const TARGET_STATUSES: TargetStatus[] = [
  'pending',
  'in_progress',
  'collecting',
  'collected',
  'partial',
  'failed',
  'client_halted',
  'cancelled',
  'ingested',
]
